<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em; padding-top:15px;">I express my deep gratitude and appreciation to the following persons who’ve gone above and beyond.</p>
<p style="text-indent:00em; padding-top:15px;">First I would like to thank God for being able to complete this book.</p>
<p style="text-indent:00em; padding-top:15px;">To Kyron and Ronnielle, for always being there when I needed. Ron and Chrystall, your valuable suggestions and guidance have been helpful in various phases of the completion of this book. To the management of Caribbean Printing/Island Publishing for providing the platform for me to introduce and perfect my craft.</p>
<p style="text-indent:00em; padding-top:15px;">Last but not least, to my close family and friends, thank you for always loving and supporting me.</p>
<p style="text-indent:00em; padding-top:15px;"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2202258d